import { render, staticRenderFns } from "./serviceProvidersTable.vue?vue&type=template&id=5d91c6ef&"
import script from "./serviceProvidersTable.vue?vue&type=script&lang=js&"
export * from "./serviceProvidersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports